import React from 'react';
import './VotingCard.styles.css';
import { VotingBar } from './VotingBar';
import { PinionManIcon, PinionManVariants } from '../../UI';
import { useAnswer } from '../../hooks/useAnswer';

interface VotingCardProps {
  likes: number;
  dislikes: number;
  answered: boolean | null;
  onAnswer: (answer: boolean) => void;
  // When false, a vote click triggers onRequireAuth instead of voting (and
  // skips the optimistic UI), so logged-out users are prompted to sign in. The
  // intended answer is passed through so it can be stashed and replayed after
  // auth ("vote first, lock on login").
  canVote?: boolean;
  onRequireAuth?: (answer: boolean) => void;
}

export const VotingCard: React.FC<VotingCardProps> = (props) => {

  const { likes, dislikes, answered, onAnswer, canVote = true, onRequireAuth } = props;

  const {
    feedback,
    handleLike: handleLikeQuestion,
    handleDisike: handleDislikeQuestion,
  } = useAnswer({ answered, likes, dislikes });

  const likeHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (!canVote) {
      onRequireAuth?.(true);
      return;
    }
    handleLikeQuestion();
    onAnswer(true);
  };

  const dislikeHandler = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (!canVote) {
      onRequireAuth?.(false);
      return;
    }
    handleDislikeQuestion();
    onAnswer(false);
  };

  return (
    <div className='flex mb-app-base items-end'>
      <PinionManIcon
        variant={feedback.answered === true ? PinionManVariants.PRIMARY : PinionManVariants.HALLOW}
        color={'orange'}
        onClick={likeHandler}
      />
      <VotingBar
        likes={feedback.likes}
        dislikes={feedback.dislikes}
      />
      <PinionManIcon
        variant={
          (feedback.answered === null || feedback.answered === true)
            ? PinionManVariants.HALLOW
            : PinionManVariants.PRIMARY
        }
        color={'purple'}
        onClick={dislikeHandler}
      />
    </div>
  );
};